import { useEffect } from 'react';
import { IonText } from '@ionic/react';
import { Page } from '../components/page/Page.tsx';
import { TrackingService } from '../support/tracking/TrackingService.ts';
import { useInstance } from '../support/ioc/useInstance';
import { NewPolicyButton } from './NewPolicyButton.tsx';
import { Logger } from '../support/debug/Logger.ts';
import { DoneIcon } from '../components/icons/Icons.tsx';
import { SkywatchService } from './SkywatchService.ts';

const Benefit: React.FC<{text: string}> = ({ text }) => (
    <div style={{marginTop: 10, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 10, fontSize: 14}}>
        <DoneIcon variant="filled" size="medium" color="insurance" />
        <b>{text}</b>
    </div>
);

export const InsuranceLandingPage: React.FC = () => {
    const tracker = useInstance(TrackingService);
    const log = useInstance(Logger);

    const skywatch = useInstance(SkywatchService);

    useEffect(() => {
        tracker.startPageView('Insurance Marketing', () => ({ vendor: 'Skywatch' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {/* NOTE: img probably no longer needs to be outside page, this was so it didn't move when we supported pull down to refresh */}
            <img style={{zIndex: 1, position: 'absolute', height: 120, top: 0, right: 0}} src="./assets/images/insurance/flying-drone.png" alt="Flying drone" />

            <Page title="Get a Quote">
                <div style={{margin: '70px 20px 0'}}>
                    <h2 style={{marginBottom: 0}}><b>Protect your passion</b></h2>
                    <h2 style={{marginTop: 0}}><b>Get <IonText color="primary">drone insurance.</IonText></b></h2>

                    <p style={{marginTop: 10, fontSize: 15}}>Get quick and affordable drone coverage in less than 5 minutes. Now provided by Skywatch!</p>

                    <div style={{marginTop: 25, marginBottom: 35}}>
                        <Benefit text="Get covered by the month or year!" />
                        <Benefit text="Get up to $10 Million in liability" />
                        <Benefit text="Add hull coverage for drones and equipment" />
                        <Benefit text="Name additional insureds with no extra fee" />
                    </div>

                    <div>
                        <div style={{fontSize: 16, textAlign: 'center'}}><b>Quick Quotes, Customer Protection</b></div>
                        <div style={{fontSize: 16, textAlign: 'center'}}><b>No commitment or credit card required</b></div>
                    </div>
                </div>

                <NewPolicyButton />

                <div style={{margin: '30px 20px', lineHeight: 0.75}}>
                    <small><i>
                        Insurance is provided by SkyWatch Insurance Services, Inc., a licensed insurance agency that is authorized to sell property and casualty insurance products and receives commission as compensation from insurance sales.
                        Coverage is subject to the terms, conditions, and exclusions of the actual policy. Availability of coverage and product options may vary by state. For more details on our licensing,
                        please <a target="_blank" href="https://faq.skywatch.ai/hc/en-us/articles/360001031692-Is-SkyWatch-regulated">click here</a>.
                        Please refer to our <a target="_blank" href="https://www.skywatch.ai/us/terms-and-conditions-us">Terms and Conditions</a> and <a target="_blank" href="https://www.skywatch.ai/privacy-policy ">Privacy Policy</a> for further information.
                    </i></small>
                </div>
            </Page>
        </>
    );
};
